/* ============================================================
   hljs theme CSS — vendored locally (no CDN)

   The prototype CDN-loaded the highlight.js stylesheet per theme.
   The v6 CSP forbids any third-party style at runtime, so we
   instead import the theme CSS from the installed `highlight.js`
   npm package as raw strings (Vite `?inline`) and swap the active
   one into a single managed <style> element.

   Keyed by the `hljs` field on each Theme in useTheme.ts.
   ============================================================ */

// `?inline` returns the processed CSS as a string instead of injecting a
// stylesheet link — lets us pick exactly one at runtime.
import github from 'highlight.js/styles/github.css?inline'
import githubDark from 'highlight.js/styles/github-dark.css?inline'
import atomOneDark from 'highlight.js/styles/atom-one-dark.css?inline'
import monokai from 'highlight.js/styles/monokai.css?inline'
import solarizedLight from 'highlight.js/styles/base16/solarized-light.css?inline'

/** hljs style-name (Theme.hljs) → vendored CSS text. */
export const HLJS_THEME_CSS: Record<string, string> = {
  'github': github,
  'github-dark': githubDark,
  'atom-one-dark': atomOneDark,
  'monokai': monokai,
  'base16/solarized-light': solarizedLight,
}
